/**
 * Simple debounce
 *
 * @param func
 * @param wait
 * @param immediate - whether to call function at the beginning,
 *                    not at the end of timeout
 */
export default function debounce<T extends TFunc>(func: T, wait: number, immediate?: boolean) {
    let timeout: any;

    const debounced = function() {
        const context = this, args = arguments;
        clearTimeout(timeout);

        timeout = setTimeout(function() {
            timeout = null;
            if (! immediate) {
                func.apply(context, args);
            }
        }, wait);

        if (immediate && ! timeout) {
            func.apply(context, args);
        }
    };

    return debounced as (...args: Parameters<T>) => ReturnType<T>;
}

type TFunc = (...args: any[]) => any;
